import React from 'react';
import { MessageCircle } from 'lucide-react';
import { CONTACT } from './Constants';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Escríbenos por WhatsApp o llámanos',
    text: 'Cuéntanos brevemente tu situación o la de tu familiar.'
  }, {
    number: '2',
    title: 'Recibe orientación inicial',
    text: 'Te ayudaremos a entender los próximos pasos de forma clara y confidencial.'
  }, {
    number: '3',
    title: 'Avanza con mayor claridad',
    text: 'Podrás tomar una decisión más informada sobre el proceso de apoyo o rehabilitación.'
  }];
  return <section className="py-16 md:py-24 bg-azul text-white" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-160">
            ¿Cómo dar el primer paso?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-16 relative" data-id="element-161">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-0.5 bg-white/20 z-0" data-id="element-162"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-163">
              <div className="w-16 h-16 bg-celeste rounded-full flex items-center justify-center text-2xl font-bold text-azul mb-6 shadow-lg border-4 border-azul" data-id="element-164">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-165">{step.title}</h3>
              <p className="text-blue-100" data-id="element-166">{step.text}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-167">
          <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3.5 border border-transparent rounded-full shadow-lg text-base font-semibold text-azul bg-white hover:bg-gray-50 transition-colors" data-id="element-168">
            <MessageCircle className="w-5 h-5 mr-2 text-whatsapp" data-id="element-169" />
            Hablar por WhatsApp ahora
          </a>
        </div>
      </div>
    </section>;
}